import { Suspense, lazy } from 'react';

import { Spinner } from '@/common/components';
import { AppControllerType, AppRoutes } from '@/common/interfaces';

import { DynamicBaseBreadcrumb, DynamicSitesBreadcrumb } from '@/modules/AppBreadcrumb';

const RedirectsPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/Redirects.page'));
const RedirectsListPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsList.page'));
const RedirectsCreatePage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsCreate.page'));
const RedirectsEditPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsEdit.page'));
const RedirectsBulkPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsBulk.page'));

export const RedirectsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Redirects + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicRedirectsBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.RedirectsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.RedirectsBulk,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsBulkPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 760
      }
    },
    {
      path: AppRoutes.RedirectsEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.RedirectsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicRedirectsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 520
      }
    },
  ]
};
